import { useContext, useEffect, useRef, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import { ChildControlArguments } from '../../../library/Core/SmartTypes';

const OPTIONS = [
    { code: 'FREE', value: 'Free' },
    { code: 'PAID', value: 'Paid' },
];

/** Onboarding-only Alumni Membership Free/Paid control. */
const AlumniMembershipRadio = (_props: ChildControlArguments) => {
    const { state, dispatch } = useContext(SmartContext);
    const fromState = state?.data?.onboarding?.alumniMembershipCode ?? state?.data?.institute?.alumniMembershipCode;
    const [selected, setSelected] = useState<string>('FREE');
    const hydrated = useRef(false);

    useEffect(() => {
        if (hydrated.current) return;
        if (!state?.data?.onboarding && !state?.data?.institute) return;
        hydrated.current = true;
        const code = OPTIONS.some((o) => o.code === fromState) ? String(fromState) : 'FREE';
        setSelected(code);
        if (!OPTIONS.some((o) => o.code === fromState)) {
            dispatch({
                type: 'CONTROL_VALUE_CHANGE',
                payload: { dataKey: 'onboarding.alumniMembershipCode', name: 'alumniMembershipCode', value: 'FREE', errorMessages: [] },
            });
        }
    }, [state?.data?.onboarding, state?.data?.institute, fromState, dispatch]);

    const onSelect = (code: string) => {
        setSelected(code);
        dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'onboarding.alumniMembershipCode', name: 'alumniMembershipCode', value: code, errorMessages: [] },
        });
        dispatch({
            type: 'CONTROL_VALUE_CHANGE',
            payload: { dataKey: 'institute.alumniMembershipCode', name: 'alumniMembershipCode', value: code, errorMessages: [] },
        });
    };

    return (
        <fieldset>
            <legend className="form-label w-100">Alumni Membership</legend>
            {OPTIONS.map((opt) => {
                const id = `alumni-membership-${opt.code}`;
                return (
                    <div key={opt.code} className="form-check form-check-inline">
                        <input
                            id={id}
                            className="form-check-input rounded-circle"
                            type="radio"
                            name="alumni-membership"
                            value={opt.code}
                            checked={selected === opt.code}
                            onChange={() => onSelect(opt.code)}
                            onClick={() => onSelect(opt.code)}
                        />
                        <label
                            className="form-check-label"
                            htmlFor={id}
                            onClick={(e) => {
                                e.preventDefault();
                                onSelect(opt.code);
                            }}
                        >
                            {opt.value}
                        </label>
                    </div>
                );
            })}
        </fieldset>
    );
};

export default AlumniMembershipRadio;
